var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-right-info"},[_c('h4',[_vm._v(_vm._s(_vm.$t('proposal_ev_fp.general__you_are_evaluating'))+" "),_c('strong',[_vm._v(_vm._s(_vm.referance))])])])}
var staticRenderFns = []

export { render, staticRenderFns }